<template>
  <div>
    <v-btn icon small @click="dialog = ! dialog">
      <v-icon style="font-size: 18px">mdi-file-image-outline</v-icon>
    </v-btn>

    <sys-dialog-full-screen
      v-model="dialog"
      titulo="Imagem do Produto"
      :txt-titulo-lado-tireito="`Produto: ${produto.idproduto} - ${produto.descricao_produto}`"
      transition="scroll-x-transition"
    >
      <div class="conteudo-img">
        <template v-if="listaDeImagens.length">
          <v-carousel id="carousel" hide-delimiter-background>
            <v-carousel-item
              v-for="(item,i) in listaDeImagens"
              :key="i"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <div class="content-imagem">
                <img
                  class="imagem-carousel"
                  :src="`data:image/png;base64, ${item}`"
                  alt="Imagem Produto"
                />
              </div>
            </v-carousel-item>
          </v-carousel>
        </template>

        <template v-else>
          <p class="subtitle-2">O Produto não possui imagem cadastrada.</p>
        </template>
      </div>
    </sys-dialog-full-screen>
  </div>
</template>

<script>
import SysDialogFullScreen from "../padraoDeLayout/SysDialogFullScreen"
import ProdutoAPI from "../../api/produto"

export default {
  name: "ImagemProdutoDialog",
  components: {SysDialogFullScreen},
  props: {
    produto: {
      type: Object,
      requied: true
    }
  },
  data: () => ({
    dialog: false,
    listaDeImagens: [],
    ultimoProdutoSelecionado: ""
  }),
  watch: {
    dialog (novoValor) {
      if (novoValor && this.ultimoProdutoSelecionado !== this.produto.idproduto) {
        this.buscarImagemDoProduto()
        this.ultimoProdutoSelecionado = this.produto.idproduto
      }
    }
  },
  methods: {
    buscarImagemDoProduto () {
      const headers = this.Helpers.iniciarRequisicao()
      const params = {
        idproduto: this.produto.idproduto
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        ProdutoAPI.getImagemProduto(headers, params)
          .then(response => {
            const {token, listaDeImagens} = response.data
            localStorage.token = token
            this.listaDeImagens = listaDeImagens;
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style scoped>
.conteudo-img {
  background: rgba(0,0,0,.1);
  height: 91vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
#carousel {
  width: 900px;
  align-items: center;
  justify-content: center;
}
.content-imagem {
  height: 100%;
  display: flex;
}
.imagem-carousel {
  background-size: cover;
  margin: auto;
  max-height: 80vh;
  max-width: 700px;
  min-height: 40vh;
  min-width: 350px;
}
</style>
